import { create, StoreApi, UseBoundStore } from "zustand";
import { PostSlice, postSlice } from "./slices/post.slice";

interface Store {
  posts: UseBoundStore<StoreApi<PostSlice>>;
}

export const useGlobalStore = create<Store>()(() => ({
  posts: postSlice,
}));

export const usePostStore = () => useGlobalStore().posts();
